module.exports = __webpack_public_path__ + "static/media/screenshot-03.f679d423.jpg";